module.exports = "/virtual-football/img/video/video-header-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/video-header-bck.png
// module id = 311
// module chunks = 6